import { useSelector } from 'react-redux';

export const useCurrentOrderSinglePersonalizationValue = () => {
  const {
    additionalData: { selectedStudent },
    v3Order: { orders },
    shoot: { shoot: shootInfo },
  } = useSelector((state) => state);

  const shootEventId = shootInfo?.event_id || shootInfo?.id;
  const orderKey =
    shootEventId && selectedStudent?.id
      ? `${shootEventId}-${selectedStudent.id}`
      : null;
  const order = orderKey ? orders[orderKey] : null;

  if (order) {
    for (const cartItem of order.cartItems) {
      // Check personalizationValue on the cartItem

      if (
        cartItem.personalizationValue &&
        cartItem.personalizationValue !== null
      ) {
        return cartItem.personalizationValue;
      }

      // If no personalizationValue on the cartItem, check its childProducts
      if (cartItem.children) {
        for (const childProduct of cartItem.children) {
          if (
            childProduct.personalizationValue &&
            childProduct.personalizationValue !== null
          ) {
            return childProduct.personalizationValue;
          }
        }
      }
    }
  }

  return null;
};
